import { useEffect, useState, type RefObject } from 'react'

function videoHasFrames(el: HTMLVideoElement): boolean {
  return el.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA && el.videoWidth > 0 && el.videoHeight > 0
}

/** True once a bound Chime (or other) video element is rendering frames. */
export function useVideoElementReady(
  ref: RefObject<HTMLVideoElement | null>,
  enabled: boolean,
  resetKey?: string | number | null,
): boolean {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    setReady(false)
    if (!enabled) return

    const el = ref.current
    if (!el) return

    const sync = () => {
      setReady(videoHasFrames(el))
    }

    sync()
    el.addEventListener('loadeddata', sync)
    el.addEventListener('playing', sync)
    el.addEventListener('resize', sync)
    el.addEventListener('canplay', sync)

    const poll = window.setInterval(sync, 200)

    return () => {
      el.removeEventListener('loadeddata', sync)
      el.removeEventListener('playing', sync)
      el.removeEventListener('resize', sync)
      el.removeEventListener('canplay', sync)
      window.clearInterval(poll)
    }
  }, [enabled, ref, resetKey])

  return ready
}
